import { ItemInfrastructureDto } from '@nohara-dxdev/mt-common';

import { InfrastructureItemData } from '../hooks/use-infrastructure-item-mapping';

import { formatItemBuilding } from './format-item-building';

export interface InfrastructureRow {
  id: string;
  itemNumber: string;
  name: string;
  room: string;
  circuitName: string;
  typeOfPower: string;
  load: number | null;
  unit: string;
  isNew: boolean;
  infrastructure: ItemInfrastructureDto;
}

export function buildInfrastructureRows({
  infrastructures,
  currentItemId,
  infrastructureType,
  direction,
  getItem,
  circuitMap,
}: {
  infrastructures: ItemInfrastructureDto[];
  currentItemId: string;
  infrastructureType: string;
  direction: 'child' | 'parent';
  getItem: (id: string) => InfrastructureItemData | undefined;
  circuitMap: Record<string, { id: string; name: string; formatted: string } | undefined>;
}): InfrastructureRow[] {
  const filtered = infrastructures.filter((infra) => {
    if (infra.infrastructureType !== infrastructureType) return false;
    if (direction === 'child') return infra.parentItemId === currentItemId;
    return infra.childItemId === currentItemId;
  });

  return filtered.map((infra) => {
    const relatedItemId = direction === 'child' ? infra.childItemId : infra.parentItemId;
    const item = getItem(relatedItemId);
    const config = item?.infrastructureRelationshipConfigs?.find(
      (c) => c.infrastructureType === infrastructureType,
    );
    const circuitId = 'circuitId' in infra ? (infra as any).circuitId : undefined;
    const circuit = circuitId ? circuitMap[circuitId] : undefined;

    return {
      id: relatedItemId,
      itemNumber: item?.itemNumber ?? '',
      name: item?.name ?? '',
      room: formatItemBuilding(item?.building?.name, item?.floor?.name, item?.locationEntity?.name),
      circuitName: circuit?.name ?? '',
      typeOfPower: circuit?.formatted ?? '',
      load: config?.load ?? null,
      unit: config?.unit ?? '',
      isNew: (infra as any).isNew === true,
      infrastructure: infra,
    };
  });
}
